module.exports = "/fonts/line-awesome.ttf?4d42f5f0c62a8f51e876c14575354a6e";